export const environment = {
  production: false,
  baseUrl: 'https://testbusiness.recuvery.com/api/business/',
  requestUrl: 'https://testrequest.recuvery.com/',
  // baseUrl: 'http://localhost:3000/business/',
  captcha_site_key: '6LeF1qMqAAAAAMLgbI3OtRmFXel366IZg7T7ZN0c',
  google_client_id: '806376654871-odcr85vi8263t4kmu0jerh8b7ns5euqq.apps.googleusercontent.com',
  app_version: 1,
  app_type: 2,
  device_type: 0,
  device_token: 'Website',
  environment: 'TEST',
  url: 'https://testbusiness.recuvery.com/',
  socketBaseUrl: 'https://testbusiness.recuvery.com',
  websiteUrl: 'https://dev.recuvery.com/',
  intercomAppId: 'vee3hiy3',
  chatIframeUrl: "https://testchat.recuvery.com/",
  clarity_id: 'qf8eiobga2'
  // chatIframeUrl: "http://192.168.2.83:4200/"
};